<template>
  <div id="app">
    <div id="nav">
      <header class="main-header">
      <span class="back-btn"><img src="./assets/images/arrow-w.svg" alt="" @click="back"></span>
      <span class="profile-img">
       <img   v-if="getUserInfo.user_image !== ''"
            :src="getUserInfo.user_image"
            />
            <!-- <h1>{{getUserInfo.name}}</h1> -->
        <img src="https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80" alt="">
      </span>
      <div class="search-box">
        <label for="search"><img src="./assets/images/ic_search.svg" alt="" @click="search"></label>
        <input type="text" v-model="searchfile" placeholder="Search..." id="search">
      </div>
    </header>
      
      <!-- <router-link to="/about">About</router-link> -->
    </div>
    <router-view/>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
  data(){
    return{
    // user_image: {},
    searchfile:""
  };
  },
 
  // watch:{
  //   '$route.params.name'(to){
  //     this.$route.params.name = to || '';
  //     this.userFile();
  //   }
  // },
  computed:{
          ...mapGetters(['getUserInfo',"getFolderPath"])
  },
 async mounted(){

    // alert('again');
    await this.$store
        .dispatch({
          type: "getUserProfile"
        })
        //  console.log( this.getUserInfo.percentage)
        
        // .then(data => {
        //   // user_Info
        // //  this.user_mage=data
        //   console.log("data",data)
        // })
        // .catch(err => {
        //   console.log(err);
        // });
  
  },
 methods:{
  
   search(){
      this.$router.push('/search')
    this.$store
        .dispatch({
           type : 'search',
           payload:{
              search: this.searchfile           
           }
        })
        .then(data => {
          console.log('data: ',data);
          // this.folder
          // this.folder_path=data
        })
        .catch(err => {
          console.log(err);
        });
  },
back:function(){
      this.$router.go(-1)
    }
 } 
}
</script>


